export const neutralGender = "neutralGender.svg";

export const getRelationImage = (relation, gender) => {
  const relationKey = `${relation}_${gender}`;
  const relationImage = RelationMap[relationKey];
  if (relationImage) {
    return relationImage;
  }
  return neutralGender;
};

export const RelationMap = {
  Self_M: "male.svg",
  Self_F: "female.svg",
  Mother_F: "mother.svg",
  Brother_M: "brother.svg",
  Daughter_F: "daughter.svg",
  Father_M: "father.svg",
  Husband_M: "male.svg",
  Sister_F: "sister.svg",
  Son_M: "son.svg",
  Wife_F: "female.svg",
  "Daughter-in-law_F": "daughterInLaw.svg",
  "Father-in-law_M": "Father-in-lawW.svg",
  "Mother-in-law_F": "Mother-in-lawW.svg",
  "Son-in-law_M": "sonInLaw.svg",
  Spouse_M: "male.svg",
  Spouse_F: "female.svg",
  Others_M: "otherMale.svg",
  Others_F: "otherFemale.svg",
  Partner_M: "otherMale.svg",
  Partner_F: "otherFemale.svg",
  child_M: "son.svg",
  child_F: "daughter.svg",
  Friend_M: "otherMale.svg",
  Friend_F: "otherFemale.svg",
};

export const getImageURL = (relationName, gender) => {
  return `https://views.medibuddy.in/mb-web/public/${getRelationImage(relationName, gender)}`;
};